/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const ExposureIcon = ({ width = 24, height = 24, hidden = false, title = 'Exposure' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M6.17 7.266a15.805 15.805 0 0 0-3.4 15.558h8.565ZM24.515 3.411A15.843 15.843 0 0 0 8.786 4.94l2.643 7.966ZM33.942 19.154c.03-.382.058-.764.058-1.154a15.951 15.951 0 0 0-6.458-12.812L21.043 9.9ZM26.85 18.026l-5.006 15.482a16 16 0 0 0 11.448-10.862ZM18.31 33.984l2.568-7.944H4.183A15.98 15.98 0 0 0 18 34c.105 0 .207-.008.31-.016Z"
    />
  </svg>`;
};
